import moment from 'moment';

export function disabledDate(current) {
    // Can not select days before today and today
    return current && current < moment().subtract(1, 'd');
}

export const checkKeyDownNumberInput = (e) => {
    if (
        (e.which !== 8 && e.which !== 0 && e.which < 48 && e.which !== 13 && e.which !== 17) ||
        (e.which > 57 && e.which !== 67 && e.which !== 86) ||
        e.which == 229
    ) {
        e.preventDefault();
    }

    // var regex = new RegExp(/^[0-9]*$/);
    // var check = regex.test(key);
    // var key = e.target.value;
    // var check = regex.test(key);
    // if (e.which !== 8) {
    //     console.log(e.which);
    //     if (check == false) {
    //         e.preventDefault();
    //     }
    // }
    //  // var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    // // console.log(regex.test(key));
    // // if (regex.test(key) == false) {
    // //     event.preventDefault();
    // // }
};
